import { useParams } from 'react-router';
import { useQuery } from '@apollo/client';

import { useCompanySettingsQuery } from 'common/hooks/useCompanySettings';
import ModalProvider from 'components/ModalProvider';
import FullPageLayout from 'features/Work/components/FullPageLayout';

import { ClientContactsProvider } from '../../../../hooks/useClientContacts';
import { useGetClient } from '../../../../pages/Clients/hooks/useGetClient';
import { useInvoicingSpecialMentionsQuery } from '../../../hooks/useInvoicingSpecialMentionsQuery';
import { QuoteDocument } from '../../hooks/queries/useGetQuote/graphql/quote.gql';
import { QuoteModalsProvider } from '../../hooks/useQuoteModals';
import Preview from './components/Preview';

const PreviewPage = () => {
  const { quoteId } = useParams<{ quoteId: string }>();

  const { data, ...quoteQuery } = useQuery(QuoteDocument, {
    variables: { quoteId },
  });

  const { client, ...clientQuery } = useGetClient(data?.quote.clientId);

  const { companySettings, ...companySettingsQuery } =
    useCompanySettingsQuery();

  const { invoicingSpecialMentions, ...specialMentionsQuery } =
    useInvoicingSpecialMentionsQuery();

  const isLoading =
    clientQuery.loading ||
    companySettingsQuery.loading ||
    quoteQuery.loading ||
    specialMentionsQuery.loading;

  const hasError =
    clientQuery.error !== undefined ||
    quoteQuery.error !== undefined ||
    specialMentionsQuery.error !== undefined;

  return (
    <ModalProvider>
      <FullPageLayout hasError={hasError} loading={isLoading}>
        {data?.quote && client ? (
          <ClientContactsProvider
            client={client}
            clientContactIds={data.quote.clientContactIds}
          >
            <QuoteModalsProvider>
              <Preview
                client={client}
                companyLogoUrl={companySettings?.logoUrl}
                invoicingSpecialMentions={invoicingSpecialMentions}
                quote={data.quote}
              />
            </QuoteModalsProvider>
          </ClientContactsProvider>
        ) : null}
      </FullPageLayout>
    </ModalProvider>
  );
};

export default PreviewPage;
